var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMylocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 10.6655C15.625 13.7721 13.1066 16.2905 10 16.2905M15.625 10.6655C15.625 7.55893 13.1066 5.04053 10 5.04053M15.625 10.6655H17.5M10 16.2905C6.8934 16.2905 4.375 13.7721 4.375 10.6655M10 16.2905V18.1655M4.375 10.6655C4.375 7.55893 6.8934 5.04053 10 5.04053M4.375 10.6655H2.5M10 5.04053V3.16553M11.875 10.6655C11.875 11.7011 11.0355 12.5405 10 12.5405C8.96447 12.5405 8.125 11.7011 8.125 10.6655C8.125 9.62999 8.96447 8.79053 10 8.79053C11.0355 8.79053 11.875 9.62999 11.875 10.6655Z",
    stroke: "#B6A884",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylocation);
export default __webpack_public_path__ + "static/media/mylocation.5ef7d71fbc58def1178554efb81f4ef6.svg";
export { ForwardRef as ReactComponent };